import React, { useState } from 'react';
import classNames from 'classnames';

import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Modal,
  VideoPlayer,
} from '..';

import './style.scss';

const VideoPopup = ({ className, embedUrl, thumbnail, title, showIcon = true }) => {
  const [displayModal, setDisplayModal] = useState(false);

  const classes = classNames('VideoPopup', className);

  const closeVideoModal = () => {
    setDisplayModal(false);
  };

  const onClickOpenVideoModal = (e) => {
    e.preventDefault();
    setDisplayModal(true);
  };

  return (
    <div className={classes}>
      <div className="aspect-ratio--16-9--wrapper">
        <div className="aspect-ratio--16-9--inner-wrapper">
          <a href="#" onClick={(e) => onClickOpenVideoModal(e)}>
            <div className="icon icon-play" />
            <Image
              src={thumbnail}
              alt={title}
              width="500px"
              includeWebP
            />
          </a>
        </div>
      </div>
      { showIcon && (
        <div className="icon icon-play icon-variant-4" />
      )}

      <h4 className="mt-2 mb-2"><a href="#" onClick={(e) => onClickOpenVideoModal(e)}>{title}</a></h4>
      { displayModal && (
        <Modal onClose={closeVideoModal}>
          <VideoPlayer title={title} url={embedUrl} isModal />
        </Modal>
      )}
    </div>
  );
};

export default VideoPopup;
